import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { usePermissions } from 'hooks/usePermissions'

import { selectUserRoles } from 'store/global'

export function useUserRoles() {
  const permissions = usePermissions()

  const allUserRoles = useSelector(selectUserRoles)

  const [displayedRoles, setDisplayedRoles] = useState([])

  useEffect(() => {
    const nextRoles = allUserRoles.filter(({ name }) => !!permissions[name])
    setDisplayedRoles(nextRoles)
  }, [permissions])

  return displayedRoles
}
